import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HashLink as Link } from 'react-router-hash-link';
import { Spring } from 'react-spring';
import { ToastContainer, toast, cssTransition } from 'react-toastify';
import SweetAlert from 'sweetalert-react';

import {
  APIHandler,
  StorageHandler,
  BackVideo,
  DataHandler,
  StoreButtons,
} from 'C4';
import { storageKeys, bgVideo } from 'settings';

import 'react-toastify/dist/ReactToastify.css';
import Logo from 'assets/images/logo/logo_beta.png';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

export default class HomeView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: '',
      unreadMessageCount: 0,
      lastCheckedMessages: '',
      appId: -1,
      userStatus: 'startTraining',
      noAgent: false,
    };
  }

  componentWillMount() {
    document.body.classList.add('no-scroll');
    StorageHandler.load(storageKeys.lastCheckedMessage).then((res) => {
      if (res) {
        this.setState({ lastCheckedMessages: res });
      }
      this.checkForUnreadMessages();
    });

    StorageHandler.load(storageKeys.user).then((res) => {
      if (res.training_graduated) {
        return this.setState({ userStatus: 'graduated' });
      }
      if (res.training_started) {
        return this.setState({ userStatus: 'continueTraining' });
      }
      return this.setState({ userStatus: 'startTraining' });
    });
  }

  componentDidMount() {
    const d = new Date(Date.now());
    const leading = (val) => `0${val}`.slice(-2);

    StorageHandler.load(storageKeys.user).then((user) => {
      if (user && user.sales_companion_registered === null) {
        const obj = user;
        const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(
          d.getDate(),
        )}`;
        DataHandler.matchAppId().then((appId) => {
          APIHandler.updateUser(appId, obj.email, [
            { param: 'sales_companion_registered', val: date },
          ]).then((res) => {
            if (res) {
              obj.sales_companion_registered = date;
              StorageHandler.save(storageKeys.user, obj);
            }
          });
        });
      }
    });
    DataHandler.matchAppId().then((appId) => {
      this.setState({ appId });
      StorageHandler.exists(storageKeys.announcement).then(
        (announcementShownBefore) => {
          if (!announcementShownBefore) {
            APIHandler.getAnnouncement(appId).then((res) => {
              let weblink = '';
              if (res && res[0] && res[0].weblink) {
                weblink = res[0].weblink
              }

              let message = '';
              if (res && res[0] && res[0].message) {
                message = res[0].message
              }

              const TaostContent = () => (
                <div>
                  <a
                    data-fancybox="rewards"
                    data-type="iframe"
                    data-src={weblink}
                    href={weblink}
                    key="rewards"
                  >
                    <p>
                      <span dangerouslySetInnerHTML={{ __html: message }} />
                      <a>
                        {'Click Here >'}
                      </a>
                    </p>
                  </a>
                </div>
              );

              if (res.length !== 0) {
                toast.info(TaostContent, {
                  position: 'top-center',
                  autoClose: false,
                  closeOnClick: false,
                  transition: Zoom,
                  hideProgressBar: true,
                  pauseOnHover: true,
                  draggable: true,
                  toastId: 'announcement',
                  onClose: () =>
                    StorageHandler.save(
                      storageKeys.announcement,
                      res.copy,
                      604800,
                    ), // expires in a week
                });
              }
              return null;
            });
          }
        },
      );
    });
  }

  componentWillUnmount() {
    document.body.classList.remove('no-scroll');
  }

  setQuery() {
    const { query } = this.state;
    if (query.length > 0) {
      StorageHandler.save(storageKeys.lastSearchQuery, query);
    }
  }

  checkForUnreadMessages() {
    DataHandler.requestWithId(
      APIHandler.getUnreadMessages,
      this.state.lastCheckedMessages,
    ).then((res) => {
      if (res && res.missed_items && res.missed_items[0]) {
        this.setState({ unreadMessageCount: res.missed_items[0].count });
      }
    });
  }

  render() {
    const { unreadMessageCount, appId, userStatus, noAgent } = this.state;

    const close = () => {
      this.setState({
        noAgent: false,
      });
    };

    return (
      <div className='homeContainer'>
        {bgVideo && <BackVideo />}
        <div className='bgHome' />
        <div className='buttonWrapper'>
          Download now:
          <StoreButtons />
        </div>
        <img src={`/${Logo}`} className='homeLogo' alt='logo' />
        <Spring
          from={{ transform: 'translateY(30%)', opacity: 0 }}
          to={{ transform: 'translateY(0%)', opacity: 1 }}
        >
          {(props) => (
            <div className='homeView' style={props}>
              <div className='homeView__title'>
                <h1>{i18n.translate('homeScreen.title')}</h1>
                <div className='homeView__title--line' />
                <div className='homeView__title--action'>
                  <form>
                    <Link
                      to='/main/search'
                      onClick={() => {
                        this.setQuery();
                      }}
                    >
                      <button type='submit' className='searchButton'>
                        <FontAwesomeIcon icon={['fas', 'search']} />
                      </button>
                    </Link>
                    <input
                      type='text'
                      placeholder={i18n.translate('general.search')}
                      onChange={(e) => {
                        const { value } = e.target;
                        this.setState({ query: value });
                      }}
                    />
                    <Link
                      to='/main/search'
                      onClick={() => {
                        this.setQuery();
                      }}
                    >
                      <button type='submit' className='searchButton'>
                        <FontAwesomeIcon icon={['fas', 'search']} />
                      </button>
                    </Link>
                  </form>
                  <div className='homepage__buttons'>
                    <Link to='/main/hotel-showroom' className='startTrain'>
                      <p>{i18n.translate('nav.showcases')}</p>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Spring>
        <div className='top-bar' />
        <div className='bottom-bar' />
        {/* <SweetAlert
          title="This feature is Coming Soon"
          show={noAgent}
          imageUrl={Logo2}
          imageWidth="50rem"
          imageHeight="50rem"
          html
          text=""
          customClass="noAgent"
          showConfirmButton={false}
          cancelButtonText={i18n.translate('general.close')}
          showCancelButton
          onConfirm={close}
          onCancel={close}
          onEscapeKey={close}
          onOutsideClick={close}
        /> */}
        <ToastContainer
          draggablePercent={60}
          autoClose={false}
          newestOnTop
          rtl={false}
          pauseOnVisibilityChange
          draggable
        />
      </div>
    );
  }
}
